import classNames from './QuizDetailsHeading.module.scss';
import classes from 'classnames';

import { useAppSelector } from '@/store';
import { unitSelector } from '@/store/reducers/unit';
import UseUnitsAssets from '@/hooks/UseUnitsAssets';
import { UnitAssets } from '@/types/units';

interface QuizDetailsHeadingProps {
  className?: string;
}

const QuizDetailsHeading = ({ className }: QuizDetailsHeadingProps) => {
  const { selectedUnit } = useAppSelector(unitSelector);
  const { unitsAssets } = UseUnitsAssets();
  const unitAssets: UnitAssets = unitsAssets[selectedUnit.order || 1];

  const content = (
    <>
      <span style={{ color: unitAssets.modalBorderColor }}>{selectedUnit?.name}</span>
    </>
  );

  return <div className={classes(classNames.quizDetailsHeading, className)}>{content}</div>;
};

export default QuizDetailsHeading;
